import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgGroup = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#4384F5",
			fillRule: "nonzero",
			d: "M9 .667A8.336 8.336 0 0 0 .667 9c0 4.6 3.733 8.333 8.333 8.333S17.333 13.6 17.333 9 13.6.667 9 .667zM5.667 13.583a2.084 2.084 0 1 1 .001-4.168 2.084 2.084 0 0 1-.001 4.168zm1.25-7.916a2.084 2.084 0 1 1 4.168.001 2.084 2.084 0 0 1-4.168-.001zm5.416 7.916a2.084 2.084 0 1 1 .002-4.168 2.084 2.084 0 0 1-.002 4.168z"
		})
	})
});
export default SvgGroup;
